import axios from 'axios';
import { store } from '../redux/store';
import { initializeAuth, logout, updateTokens } from '../redux/slices/authSlice';
import { API_URL } from '../config/apiConfig';

let inFlight;
export const sessionIsCurrent = sessionId => Boolean(sessionId && store.getState().auth.sessionId === sessionId && localStorage.getItem('sessionId') === sessionId);
export const expireSession = sessionId => {
  if (!sessionIsCurrent(sessionId)) return;
  store.dispatch(logout());
  window.dispatchEvent(new CustomEvent('sessionExpired', { detail: { reason: 'Sua sessão expirou. Por favor, faça login novamente.' } }));
};
export const refreshSession = () => {
  const { sessionId, refreshToken } = store.getState().auth;
  if (inFlight?.sessionId === sessionId) return inFlight.promise;
  const refresh = async () => {
    if (!sessionIsCurrent(sessionId)) throw new Error('SESSION_CHANGED');
    // Another tab may have rotated this grant while this tab waited for the lock.
    store.dispatch(initializeAuth());
    if (store.getState().auth.refreshToken !== refreshToken) return store.getState().auth.token;
    if (!refreshToken) { expireSession(sessionId); throw new Error('NO_REFRESH_TOKEN'); }
    try {
      const { data } = await axios.post(`${API_URL}/auth/refresh`, { refreshToken });
      if (!sessionIsCurrent(sessionId)) throw new Error('SESSION_CHANGED');
      if (!data.accessToken || !data.refreshToken) throw new Error('INVALID_REFRESH_RESPONSE');
      store.dispatch(updateTokens({ ...data, sessionId }));
      return data.accessToken;
    } catch (error) {
      if (error.response?.status === 401 || error.response?.status === 403 || error.message === 'INVALID_REFRESH_RESPONSE') expireSession(sessionId);
      throw error;
    }
  };
  const promise = (navigator.locks?.request ? navigator.locks.request('ass-auth-refresh', refresh) : refresh()).finally(() => {
    if (inFlight?.promise === promise) inFlight = null;
  });
  inFlight = { sessionId, promise };
  return promise;
};
